import React from "react";

const details = [
  {
    title: "Social Media Strategy & Management",
    text:
      "Content systems, platform playbooks, and community storytelling that keep your brand top-of-mind and generate qualified leads.",
    cta: "Plan social growth",
  },
  {
    title: "Personal Branding Management",
    text:
      "We position founders and leaders with authority-driven narratives, consistent publishing, and visibility that converts to demand.",
    cta: "Build authority",
  },
  {
    title: "SEO, GEO Optimization & Paid Media",
    text:
      "Search-first growth with SEO and GEO optimization, plus performance campaigns on Google Ads and Meta Ads to capture ready buyers.",
    cta: "Scale lead flow",
  },
];

export default function ServicesDetailSection() {
  return (
    <section className="services-detail">
      <div className="section-inner">
        {details.map((item, index) => (
          <div
            className={`detail-row ${index % 2 === 1 ? "reverse" : ""}`}
            key={item.title}
          >
            <div className="detail-copy">
              <h3>{item.title}</h3>
              <p>{item.text}</p>
              <a className="btn secondary" href="#contact">
                {item.cta}
              </a>
            </div>
            <div className="detail-visual">
              {index === 0 ? (
                <img
                  className="detail-image"
                  src="/soc.webp"
                  alt="Social media strategy and management services illustration"
                />
              ) : index === 1 ? (
                <img
                  className="detail-image"
                  src="/per.webp"
                  alt="Personal branding management service visual"
                />
              ) : index === 2 ? (
                <img
                  className="detail-image"
                  src="/meta.webp"
                  alt="SEO and paid media campaign performance visual"
                />
              ) : (
                <>
                  <div className={`visual-card visual-${index + 1}`}></div>
                  <div className="visual-overlay"></div>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
